export class SetDecoderBoardSettingsAction {
    constructor(settings) {
        this.name = 'SetDecoderBoardSettings';
        this.isDeviceAction = true;
        this.data = {};
        this.data.settings = settings;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2V0RGVjb2RlckJvYXJkU2V0dGluZ3NBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL1NldERlY29kZXJCb2FyZFNldHRpbmdzQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLE1BQU0sT0FBTyw2QkFBNkI7SUFLeEMsWUFBWSxRQUFnQjtRQUpaLFNBQUksR0FBRyx5QkFBeUIsQ0FBQztRQUNqQyxtQkFBYyxHQUFHLElBQUksQ0FBQztRQUMvQixTQUFJLEdBQWlDLEVBQUUsQ0FBQztRQUc3QyxJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUM7SUFDaEMsQ0FBQztDQUNGIn0=